module.exports = __webpack_public_path__ + "img/bell.89d9b690.svg";